module.exports = __webpack_public_path__ + "img/SEL24F14GM.3b0658ea.jpg";